<template>
    <div>
        <div class="bg-white p-3">
            <div>
                <div>
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a
                                    class="nav-link active"
                                    data-toggle="tab"
                                    href="#single-request"
                                    role="tab"
                                    aria-selected="false"
                            >
                                {{ $t("money_request.single_request") }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#gregarious-request"
                                    role="tab"
                                    aria-selected="false"
                            >
                                {{ $t("money_request.gregarious_request") }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-content">
                <div class="tab-pane active" id="single-request">
                    <form
                            @submit.prevent="submitSingleRequest($event, query)"
                            id="single-request-form"
                            class="kt-form p-3 my-4"
                    >
                        <kt-form-section>
                            <kt-row>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="full_name">
                                            {{ $t("money_request.full_name") }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="full_name"
                                                name="full_name"
                                                v-model="query.full_name"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="phone">
                                            {{ $t("money_request.phone") }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="phone"
                                                name="phone"
                                                v-model="query.phone"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                            <kt-row>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="amount">
                                            {{ $t("money_request.amount") }}
                                        </kt-form-label>
                                        <currency-input
                                                dir="rtl"
                                                :currency="{
                      suffix: '',
                      prefix: '',
                    }"
                                                v-model="query.amount"
                                                :precision="0"
                                                :value-range="{ min: 10000 }"
                                                :value-as-integer="true"
                                                :allow-negative="false"
                                                id="amount"
                                                name="amount"
                                                class="form-input form-control"
                                                :placeholder="
                      $t('pardakht_shakhsi.form.placeholder.rial_amount')
                    "
                                        >
                                        </currency-input>
                                        <p class="mt-2 mx-2">
                                            {{
                                                query.amount ? Number(query.amount).toLocaleString() + ' ریال ' : ''
                                            }}</p>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="description">
                                            {{ $t("money_request.description") }}
                                        </kt-form-label>
                                        <kt-form-textarea
                                                id="description"
                                                name="description"
                                                v-model="query.description"
                                        >
                                        </kt-form-textarea>
                                    </kt-form-group>
                                </kt-col>
                                <!-- <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="payment_method">
                                            {{ $t("label.money_request.payment_method") }}
                                        </kt-form-label>
                                        <kt-form-select
                                                size="3"
                                                id="payment_method"
                                                class="form-control"
                                                name="payment_method"
                                                v-model="payment_method"
                                        >
                                            <option
                                                    v-bind:value="1"
                                            >
                                                درگاه پرداخت اینترنتی (IPG)
                                            </option>
                                        </kt-form-select>

                                    </kt-form-group>
                                </kt-col> -->
                            </kt-row>
                        </kt-form-section>
                        <hr class="my-4"/>
                        <kt-form-action>
                            <kt-button
                                    id="form-btn"
                                    class="btn btn-success btn-wide"
                                    type="submit"
                                    variant="success"
                            >
                                {{ $t("money_request.submit") }}
                            </kt-button>
                        </kt-form-action>
                    </form>
                </div>
                <div class="tab-pane" id="gregarious-request">
                    <form
                            @submit.prevent="submitGroupRequest($event, query)"
                            id="gregarious-request-form"
                            class="kt-form p-3 my-4"
                    >
                        <div
                                class="rounded-circle border border-success p-2 mx-auto"
                                style="width: fit-content; border-width: 3px !important"
                        >
                            <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    enable-background="new 0 0 24 24"
                                    height="48px"
                                    viewBox="0 0 24 24"
                                    width="48px"
                                    fill="#00bea5"
                            >
                                <rect fill="none" height="24" width="24"/>
                                <g>
                                    <path
                                            d="M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1C4.76,14.04,4.39,14,4,14 c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2 c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85C21.93,14.21,20.99,14,20,14 c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M16.24,13.65c-1.17-0.52-2.61-0.9-4.24-0.9 c-1.63,0-3.07,0.39-4.24,0.9C6.68,14.13,6,15.21,6,16.39V18h12v-1.61C18,15.21,17.32,14.13,16.24,13.65z M8.07,16 c0.09-0.23,0.13-0.39,0.91-0.69c0.97-0.38,1.99-0.56,3.02-0.56s2.05,0.18,3.02,0.56c0.77,0.3,0.81,0.46,0.91,0.69H8.07z M12,8 c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,8,12,8 M12,6c-1.66,0-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3 C15,7.34,13.66,6,12,6L12,6z"
                                    />
                                </g>
                            </svg>
                        </div>

                        <div class="my-3 d-flex justify-content-center">
                            <ul class="text-right list-unstyled">
                                <li class="bg-white mb-3">
                                    لطفا به نکات زیر در تکمیل فایل اکسل توجه نمایید:
                                </li>
                                <li class="mb-2">
                                    <img
                                            src="@/pages/dashboard/userwizard/assets/check.svg"
                                            width="16"
                                            height="16"
                                            class="filter_green"
                                    /><span class="mx-3"
                                >قالب اکسل باید مشابه
                  <a :href="excelTemplateLink()">
                    <strong style="color: red">
                      {{ $t("money_request.file_hint_second") }}
                    </strong>
                  </a>
                  باشد</span
                                >
                                </li>
                                <li class="mb-2">
                                    <img
                                            src="@/pages/dashboard/userwizard/assets/check.svg"
                                            width="16"
                                            height="16"
                                            class="filter_green"
                                    /><span class="mx-3"
                                >نام و نام خانوادگی پرداخت کننده تنها با حروف فارسی باید
                  باشد</span
                                >
                                </li>
                                <li class="mb-2">
                                    <img
                                            src="@/pages/dashboard/userwizard/assets/check.svg"
                                            width="16"
                                            height="16"
                                            class="filter_green"
                                    /><span class="mx-3"
                                >شماره همراه پرداخت کننده با صفر شروع شده و حتما 11 رقم داشته
                  باشد</span
                                >
                                </li>
                                <li class="mb-2">
                                    <img
                                            src="@/pages/dashboard/userwizard/assets/check.svg"
                                            width="16"
                                            height="16"
                                            class="filter_green"
                                    /><span class="mx-3">تکمیل فیلد جزئیات اختیاری است</span>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <label
                                    for="file"
                                    class="d-block  btn btn-outline-success btn-pill label-file  mx-auto">
                                <kt-icon type="fa" name="paperclip"></kt-icon>
                                {{ $t("money_request.select_file") }}
                            </label>
                            <input
                                    @change="processExcelFile"
                                    type="file"
                                    class="custom-file-upload d-none"
                                    name="file"
                                    id="file"
                                    accept=".xlsx"
                            />
                        </div>
                        <hr class="my-4"/>
                        <!-- <kt-col lg="3" md="3" xs="12">
                            <kt-form-group>
                                <kt-form-label for="payment_method">
                                    روش پرداخت
                                    <a class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm rounded-circle"
                                       v-if="bill_information">
                                        <span class="tooltip-text"
                                              v-text="$t('label.pardakht_shakhsi_modal_info')"></span>
                                        <i class="fas fa-info-circle"></i>
                                    </a>
                                </kt-form-label>
                                <kt-form-select
                                        size="3"
                                        id="payment_method"
                                        class="form-control"
                                        name="payment_method"
                                        v-model="payment_method"
                                >
                                    <option
                                            v-bind:value="1"
                                    >
                                        درگاه پرداخت اینترنتی (IPG)
                                    </option>
                                    <option
                                            v-bind:value="0"
                                    >
                                        پرداخت شناسه دار
                                    </option>
                                </kt-form-select>

                            </kt-form-group>
                        </kt-col> -->

                        <div class="d-flex justify-content-center">
                            <button
                                    id="form-btn"
                                    class="btn btn-success btn-wide"
                                    type="submit"
                            >
                                {{ $t("money_request.submit") }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div v-if="form_data" class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
            <form @submit.prevent="set_sms_wallet" id="settings_sms_wallet_form">
                <div class="d-flex align-items-center px-3">
                    <div class="ml-auto">
                        <span>کیف پول پیامکی</span>
                    </div>
                    <div>
                        <span>تعداد پیامک قابل ارسال</span>&nbsp;
                        <span>{{ form_data.sms_count_can_send }}</span>
                    </div>
                </div>
                <hr/>
                <div class="p-3">
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <label for="sms_charge">افزایش اعتبار پیامک</label>
                            <input
                                    type="number"
                                    id="sms_charge"
                                    class="form-control"
                                    v-model="sms_number"
                                    placeholder="تعداد پیامک"
                                    @keyup="setRechargePrice()"
                                    @change="setRechargePrice()"
                            />
                            <small class="form-text text-muted"
                            >حداقل مقدار افزایش اعتبار 10,000 ریال می باشد.</small
                            >
                        </div>
                        <input
                                name="sms_wallet_recharge_price"
                                type="number"
                                :value="sms_wallet_recharge_price"
                                style="display: none"
                                id="sms_wallet_recharge_price"
                        />
                        <div class="mr-auto">
              <span class="text-success px-2"
              >قابل پرداخت
                <span>
                    {{ moneyFormat(sms_wallet_recharge_price) + " " + $t("label.rial") }}
                </span>
              </span>
                            <button
                                    type="submit"
                                    class="btn btn-success px-4"
                                    style="border-radius: 10px"
                                    id="submit_btn_sms_wallet"
                                    :disabled="sms_wallet_form_submit_loading"
                            >
                <span v-if="sms_wallet_form_submit_loading">
                  <span class="pl-2">در حال انجام</span>
                  <span
                          class="spinner-border spinner-border-sm p-2"
                          role="status"
                  ></span>
                </span>
                                <span v-else>پرداخت</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {i18n} from "@/plugins/i18n";
import $ from "jquery";
import {BASE_PATH} from "@/common/config";
import {notificationSmsService} from '@/common/api.service'
import {mapGetters} from "vuex";
import toastr from "toastr";

export default {
    props: {
        submitSingleRequest: {
            default: function ($event, query) {
            },
            type: Function,
        },
        submitGroupRequest: {
            default: function ($event, query) {
            },
            type: Function,
        },
    },
    data() {
        return {
            active_pane: "#single-request",
            query: {
                payment_method: this.payment_method
            },
            payment_method: 1,
            ipgDisabled: false,
            billDisabled: false,
            bill_information: true,
            sms_price: '',
            sms_number: '',
            sms_wallet_recharge_price: 0,
            sms_wallet_form_submit_loading: false,
        };
    },
    watch: {
        payment_method(value) {
            if (value === '1') {
                this.query.payment_method = 1
                $('#payment_method').val(1).change();
                $('#gregarious-request #payment_method').val(1).change();
                this.bill_information = false;
            }
            if (value === '0') {
                this.query.payment_method = 0
                $('#payment_method').val(0).change();
                $('#gregarious-request #payment_method').val(0).change();
                this.bill_information = true;
            }
        }
    },
    computed: {
        ...mapGetters("notificationSms", ["form_data"]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        processExcelFile(e) {
            this.query.file = event.target.files[0];
            this.validateSize(event.target);
            this.validateFormat(event.target);
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t("money_request.file_size_hint"));
                $(file).val("");
            } else {
            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, "");
            if (extension === file_name) {
                extension = "";
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case "xlsx":
                    break;
                default:
                    alert(i18n.t("authenticate.input_format_err"));
                    $(file).val("");
            }
        },
        excelTemplateLink() {
            return BASE_PATH + "/money-request/download";
        },
        set_sms_wallet(e) {
            if (sms_wallet_recharge_price < 10000) {
                return this.toastr.error('حداقل مقدار افزایش اعتبار 10,000 ریال می باشد.')
            }

            this.sms_wallet_form_submit_loading = true;

            let params = {
                recharge_price: this.sms_wallet_recharge_price,
            };
            notificationSmsService
                    .updateSmsWallet(params)
                    .then((response) => {
                        let tracking_code = response.data.data.tracking_code;
                        location.replace(BASE_PATH + "/notification-sms/pay-recharge-wallet/" + tracking_code);
                    })
                    .catch(({response}) => {
                        this.showMsg(form, "danger", i18n.t("message.an_error_accord"));
                    })
                    .finally(() => {
                        this.sms_wallet_form_submit_loading = false;
                    });
        },
        increment() {
            this.$store.dispatch("notificationSms/increment");
        },
        setRechargePrice() {
            if (this.sms_number == '') {
                this.sms_wallet_recharge_price = 0;
            } else {
                this.sms_wallet_recharge_price = this.sms_number * this.form_data.sms_price;
            }
        },
        moneyFormat(price) {
            if (!price) return 0;
            const pieces = parseFloat(price).toFixed(0).split("");
            let ii = pieces.length;
            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ",");
            }
            return pieces.join("");
        },
    },
    mounted() {
        this.query.payment_method = 1
        this.payment_method = 1;
        this.$store.dispatch("notificationSms/fetch");
    }
};
</script>

<style scoped>
.filter_green {
    filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.special-tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;
}

.special-tooltip .tooltip-text {
    font-size: 12px;
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    min-width: 210px !important;
}

.special-tooltip .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 48%;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

.special-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>
